import styled from 'styled-components';

export const SearchFieldPill = styled.div`
  margin-bottom: 0;

  .input-group {
    border-radius: 999px;
    overflow: hidden;
    border: 1px solid var(--gray-light);
    transition: border-color 160ms ease;
  }

  .input-group:focus-within {
    border-color: var(--brand-primary);
  }

  .input-group-addon {
    border: none;
    background: var(--gray-lightest);
    border-radius: 999px 0 0 999px;
  }

  input {
    border: none;
    border-radius: 0 999px 999px 0;
    font-size: 13px;
  }
`;
